import React, {useContext} from 'react';
import {Box} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import AppContext from '../../../@crema/utility/AppContext';
import {ThemeMode} from '../../constants/AppEnums';
import Hidden from '@material-ui/core/Hidden';
import AppContextPropsType from '../../../types/AppContextPropsType';
import {useHistory} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {AppState} from '../../../redux/store';

const AppLogo = () => {
  const {themeMode} = useContext<AppContextPropsType>(AppContext);
  const useStyles = makeStyles(() => ({
    logoRoot: {
      display: 'flex',
      flexDirection: 'column',
      cursor: 'pointer',
      alignItems: 'center',
    },
    logo: {
      height: 32,
      marginRight: 10,
      marginTop: 2,
      marginBottom: 2,
    },
  }));
  const classes = useStyles();
  const history = useHistory();

  const {loc} = useSelector<AppState, AppState['currLoc']>(({currLoc}) => currLoc);

  return (
    <Box className={classes.logoRoot}
    onClick={() => {
      history.push('/dashboards/e-commerce');
    }}
    >
      <Hidden smUp>
        <img
          className={classes.logo}
          src={
            themeMode === ThemeMode.DARK
              ? './assets/images/logo-white.png'
              : './assets/images/logo.png'
          }
          alt='logo'
        />
        <Box color='text.secondary'>
          {loc.locname !== null? loc.locname : 'Unknown' }
        </Box>
      </Hidden>
      <Hidden xsDown>
        <img
          className={classes.logo}
          src={
            themeMode === ThemeMode.DARK
              ? './assets/images/logo-white-with-name.png'
              : './assets/images/logo-with-name.png'
          }
          alt='logo'
        />
        <Box component='span' color='text.secondary'>
          {loc.locname !== null? loc.locname: 'Unknown' }
        </Box>
      </Hidden>
     
    </Box>
  );
};

export default AppLogo;
